import gql from 'graphql-tag';
const UPDATE_HASHED_EMAIL_LIST = gql`
  mutation updateHashedEmailList(
    $id: ID!
    $activated: Boolean
    $stepProgress: Int
    $status: EnumFirstPartyDataStatus
    $dsp: EnumFirstPartyDataDSP
    $tag: String
    $uploadedAt: DateTime
    $csvFileName: String
    $typeOfFirstPartyData: String
  ) {
    updateHashedEmailList(
      where: { id: $id }
      data: {
        activated: $activated
        stepProgress: $stepProgress
        status: $status
        dsp: $dsp
        tag: $tag
        uploadedAt: $uploadedAt
        csvFileName: $csvFileName
        typeOfFirstPartyData: $typeOfFirstPartyData
      }
    ) {
      id
      name
      stepProgress
      status
      dsp
      typeOfFirstPartyData
      tag
      uploadedAt
      csvFileName
    }
  }
`;

export default UPDATE_HASHED_EMAIL_LIST;
